import { createActions } from 'redux-actions';
import types from './types';

// eslint-disable-next-line import/prefer-default-export
export const {
  setPendingStatus,
} = createActions(
  types.SET_PENDING_STATUS,
);
